<template>
  <v-container grid-list-xs>
      <div>
          <h1>Picking List</h1>
          <v-container grid-list-xs>
              <template>
                  <v-toolbar flat color="white">
                      
                      <v-toolbar-title>
                      <v-text-field @click="show_dialog()"
                          v-model="date"  
                          label="Delivery Date"
                          required
                      ></v-text-field>
                      </v-toolbar-title>

                      <v-spacer></v-spacer>
                      <v-btn class="font-weight-light" tile color="black" dark  @click="chk_err()"  >
                          <v-icon >play_arrow</v-icon>
                      </v-btn>
                  </v-toolbar>
              </template>
          </v-container>

        <v-dialog v-model="dialog" max-width="290">
            <v-card>
                <v-date-picker v-model="date"></v-date-picker>
                <v-spacer></v-spacer>
                    <v-btn block  @click="hide_dialog()" color="primary">Select</v-btn>
                    <v-btn block @click="hide_clear_dialog()" >Clear</v-btn>
            </v-card>
        </v-dialog>

        <v-container grid-list-xs v-if="table_details.length > 0">
            <p>Please check! Customers have 2 delivery place.</p>
            <v-data-table
                class="table"
                :headers="headers"
                :items="table_details"
                :search="search"
                :rows-per-page-items="[10, 25]">
                <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.code }}</td>
                <td class="text-xs-left">{{ props.item.name }}</td>
                <td class="text-xs-center">
                    <v-btn class="mr-2" @click="update_deli(props.item.code,0)">Delivery to Work</v-btn>
                </td>
                <td class="text-xs-center">
                    <v-btn class="mr-2" @click="update_deli(props.item.code,1)">Delivery to Home</v-btn>
                </td>
                </template>

            </v-data-table>

        </v-container>

          <v-container grid-list-xs v-if="users.length > 0">
            <v-layout row wrap>
                <v-flex md4>
                  <div class="blue darken-2 text-center">
                    <br>
                    <center><h2 class="white--text">Customer Order.</h2></center>
                    <center><h1 class="white--text">{{users[0].cnt_cus}}</h1></center>
                    <br>
                  </div>
                </v-flex>
                <v-flex md4>
                  <div class="blue lighten-2 text-center">
                    <br>
                    <center><h2 class="white--text">Count SKU.</h2></center>
                    <center><h1 class="white--text">{{users[0].cnt_item}}</h1></center>
                    <br>
                  </div>
                </v-flex>
                <v-flex md4>
                  <div class="cyan darken-2 text-center">
                    <br>
                    <center><h2 class="white--text">Total Item.</h2></center>
                    <center><h1 class="white--text">{{users[0].tot_qty}}</h1></center>
                    <br>
                  </div>
                </v-flex>
            </v-layout>
            <br><br>
            <v-btn class="font-weight-light" tile color="black" dark  @click="download_this()"  >
                <v-icon >file_download</v-icon>Picklist
            </v-btn>
            <v-btn class="font-weight-light" tile color="black" dark  @click="download_label()"  >
                <v-icon >file_download</v-icon>Label
            </v-btn>
          </v-container> 
      </div>
  </v-container>  
</template>

<script>
export default {
    data() {
    return {
        
        date: new Date().toISOString().substr(0, 10),
        dialog : false,
        users: [],
        chk:0,
        headers:[ 
          { text: 'Code', value: 'code' },
          { text: 'Name', value: 'name' },
        ],
        table_details:[],

    }
  },
    methods: {
      show_dialog(){
          this.dialog = true
          this.users = []
      },
      hide_dialog(){
          this.dialog = false
      },
      hide_clear_dialog(){
          var date_clear = new Date().toISOString().substr(0, 10)
          this.date = date_clear
          this.dialog = false
      },
      download_this(){

            window.open("https://ws.plantifulbkk.shop/picklist.php?date="+this.date);      

      },
      download_label(){

            window.open("https://ws.plantifulbkk.shop/delivery_order_by_date_export_to_csv.php?scode="+this.date); 

      },
      chk_err(){
          this.read_data_1()
      },  
      read_data() {
          const vm = this;
          vm.axios.get('https://ws.plantifulbkk.shop/get_picklist_summery.php',{
              params: {
                  scode: this.date ,
              }
          }).then(response => {
              var result = JSON.parse(JSON.stringify(response.data))
              vm.users = result

          }).catch(function (error) {
                  alert("Error")
                  console.log(error)
          })

        },
        read_data_1(){
            const vm = this;
            vm.axios.get('https://ws.plantifulbkk.shop/get_deli_dup.php',{
              params: {
                  scode: this.date ,
              }
          }).then(response => {
            var result = JSON.parse(JSON.stringify(response.data))
            vm.table_details = result
            if ( vm.table_details.length === 0 ){
              this.read_data()
            }
          })
        },
        update_deli( cust_code , para ){
                const vm = this;
                vm.axios.get("https://ws.plantifulbkk.shop/post_update_deli.php",{
                    params: {
                        sdate: this.date ,
                        scode: cust_code ,
                        stype : para ,
                    }
                }).then(result=>{
                        this.chk_err()
                    })
                .catch(function (error) {
                        alert("Error")
                        console.log(error)
                    })

        },
    },   

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/pages/pickinglist.vue